module.exports = __webpack_public_path__ + "static/saio-752e5fea49c92d57a03b4dec34299a93.jpg";